// @flow
import React from "react";
import moment from "moment";
import Highlighter from "react-highlight-words";
import { Button, LocaleLink } from "../../../common";
import I18n from "../../../../i18n/I18n";
import Helper from "../../../../helper/Helper";
import styles from "../../../orders/orderBox/OrderBox.scss";

const PicklistBox = (props: Object) => {
  const {
    item,
    searchString,
    isPrintLoading,
    exportPicklist,
    isExporting,
    printCall,
    isPrinting
  } = props;
  return (
    <div className={styles.ctr}>
      <div className={styles.flexer}>
        <div className={styles.statusCtr}>
          {item.picklist_nr ? (
            <LocaleLink to={`/stock-request/picklist/${item.picklist_nr}`}>
              <Button variant="dashed">
                <Highlighter
                  highlightClassName={styles.highlight}
                  searchWords={[searchString]}
                  autoEscape={true}
                  textToHighlight={item.picklist_nr}
                />
              </Button>
            </LocaleLink>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className={styles.attrCtr}>
        {Number(item.qty) >= 0 ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>{I18n.getText("variants.qty")}</h6>
            <div className={styles.attrVal}>
              <div className={`${styles.qty}`}>{item.qty}</div>
            </div>
          </div>
        ) : (
          ""
        )}
        {item && item.created_at ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("statement-details.order-view-created")}
            </h6>
            <div className={styles.attrVal}>
              {moment(item.created_at).format(
                `YYYY-MM-DD [${
                  Helper.getLang() === "ar" ? "" : "at"
                }] h:mm:ss a`
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        {item.warehouse_code ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("offer.warehouse-code")}
            </h6>
            <div className={styles.attrVal}>{item.warehouse_code}</div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div>
        <Button
          variant="dashed"
          className={styles.button}
          onClick={() => printCall(item.picklist_nr)}
        >
          {isPrintLoading ? (
            <div className={styles.loader} />
          ) : (
            I18n.getText("transfers.print")
          )}
        </Button>
        <Button
          variant="dashed"
          className={styles.button}
          onClick={() => exportPicklist(item.picklist_nr)}
        >
          {isPrintLoading ? (
            <div className={styles.loader} />
          ) : (
            I18n.getText("credit.tooltip-export")
          )}
        </Button>
      </div>
    </div>
  );
};

export default PicklistBox;



// WEBPACK FOOTER //
// ./src/components/stockRequest/picklistTable/picklistBox/PicklistBox.js